import {
  NullableBooleanSetting,
  useUserSettingWithDefault,
} from "shared-ts-utils-user-settings";

export const useAnonymizeUsageDataWithNullAsDefault = () => {
  return useUserSettingWithDefault<boolean | null>(
    "anonymizeUsageData",
    NullableBooleanSetting,
    null
  );
};
